import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getPlanDetail } from "redux/actions/planMaster";
import { AppState } from "redux/store";
import PlanUpdate from "./planUpdate";
import PlanUpdateHeader from "./planUpdateHeader";

const PlanUpdateIndex: React.FC = () => {
  const dispatch = useDispatch();
  const { planId } = useParams<{ planId?: string }>();

  const { currentPlan } = useSelector<AppState, AppState["planMaster"]>(
    ({ planMaster }) => planMaster
  );

  useEffect(() => {
      dispatch({ type: "SET_Plan_DATA" });
  
      if (planId !== undefined) {
        setTimeout(() => {
          dispatch(getPlanDetail(planId));
        }, 1);
      }
    }, [dispatch, planId]);

  return (
    <>
      {currentPlan ? (
        <AppAnimate animation="transition.slideUpIn" delay={200}>
          <AppCard>
            <PlanUpdateHeader plan={currentPlan} />
           
            <AppGridContainer>
              <PlanUpdate Plan={currentPlan} /> 
            </AppGridContainer>
          </AppCard>
        </AppAnimate>
      ) : null}
      <AppInfoView />
    </>
  );
};

export default PlanUpdateIndex;
